import { DialogStateManager, useDialog } from '@plato/ui-legacy/components/dialog/dialog-provider';
import { useTranslation } from 'react-i18next';
import type { CrmTaskInputDTO } from '../../../server/dto/crm-task-input-dto.ts';
import {
    type TaskBulkFormValues,
    type TaskFormSuggestion,
    TaskBulkFormDialog,
} from '../../tasks/components/task-bulk-form-dialog.tsx';

type TaskBulkDialogProps = {
    title?: string;
    initialValues: Partial<CrmTaskInputDTO>;
    onSubmit: (tasks: CrmTaskInputDTO[]) => void;
    suggestions?: TaskFormSuggestion[];
};

export const TaskBulkDialog = DialogStateManager.create<TaskBulkDialogProps>(
    ({ title, initialValues, onSubmit, suggestions }: TaskBulkDialogProps) => {
        const { t } = useTranslation('tasks');
        const { visible, remove } = useDialog();
        const { assignedToId, ...shared } = initialValues;

        const bulkInitialValues: Partial<TaskBulkFormValues> = assignedToId
            ? { ...shared, assignedToIds: [assignedToId] }
            : shared;

        return (
            <TaskBulkFormDialog
                open={visible}
                onClose={remove}
                onSubmit={({ assignedToIds, ...values }) => {
                    onSubmit(assignedToIds.map((id) => ({ ...values, assignedToId: id })));
                    remove();
                }}
                isSubmitting={false}
                title={title || t('tasks__form_create_title')}
                initialValues={bulkInitialValues}
                suggestions={suggestions}
            />
        );
    },
);
